var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { createFilterOptions, Typography } from '@mui/material';
import { gridClasses } from '@mui/x-data-grid-premium';
import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { AdjustmentTypeList, checkDefaultTrackingTypeAPI, getAvailableQuantityAPI, getProductPriceAPI, LocationByWarehouseList } from '../../../api/url';
import { generateCodeName } from '../../../builderPackage/common/commonFunctions';
import { EditableDataGrid } from '../../../builderPackage/components/editableDataGrid/editableDataGrid';
import { RowModeIds } from '../../../builderPackage/components/editableDataGrid/editableDataGrid.entity';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { useAppSelector } from '../../../store/hooks';
import { faintblue, secondaryTextGray } from '../../../theme/palette';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { adjustmentTypeListGet, checkDefaultTrackingTypeAPIGet, getAvailableQuantityAPIGet, getProductPriceAPIGet, locationByWarehouseListGet, productListGet, serialNumberListGet } from '../apiCall';
import { StockAdjustmentKeys } from '../entity';
export default function StockAdjustmentPartDataGrid(props) {
    var _a;
    var _this = this;
    var _props$value, _value$name, _getLocalStorageItem, _getLocalStorageItem2, _crud$StockAdjustment, _crud$StockAdjustment2, _crud$StockAdjustment3, _crud$StockAdjustment4, _crud$StockAdjustment5;
    var onChange = props.onChange, value = props.value, _b = props.name, name = _b === void 0 ? "StockAdjustmentRequisitionDetail" : _b, error = props.error;
    var warehouseId = props === null || props === void 0 || (_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.Warehouse;
    var crud = useAppSelector(function (state) { return state.crud; });
    var dispatch = useDispatch();
    var rows = (_value$name = value === null || value === void 0 ? void 0 : value[name]) !== null && _value$name !== void 0 ? _value$name : [];
    var filter = createFilterOptions();
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var UserParentOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var totalsRow = useMemo(function () {
        var totals = {
            id: RowModeIds.Total,
            Product: 'Total',
            PurchasePrice: 0,
            TotalCostPrice: 0,
            AdjustedQuantity: 0
        };
        rows.forEach(function (r) {
            if (r.id === RowModeIds.Total)
                return;
            if (typeof r.PurchasePrice === 'number')
                totals.PurchasePrice += r.PurchasePrice;
            if (typeof r.TotalCostPrice === 'number')
                totals.TotalCostPrice += r.TotalCostPrice;
            if (typeof r.AdjustedQuantity === 'number')
                totals.AdjustedQuantity += r.AdjustedQuantity;
        });
        return totals;
    }, [rows]);
    useEffect(function () {
        adjustmentTypeListGet({
            key: StockAdjustmentKeys.adjustmentTypes,
            request: {
                RequisitionType: 'Adjustment'
            },
            url: AdjustmentTypeList
        });
    }, []);
    useEffect(function () {
        if (warehouseId) {
            locationByWarehouseListGet({
                key: StockAdjustmentKeys.locations,
                request: {
                    WarehouseId: warehouseId
                },
                url: LocationByWarehouseList
            });
        }
    }, [warehouseId]);
    var processRowUpdate = function (newRow, oldRow) { return __awaiter(_this, void 0, void 0, function () {
        var _newRow$Product, _value$name2, _newRow$Product2, _oldRow$Product, _newRow$Product6, rows, _newRow$Product3, _defaultAdjustmentRes, _checkDefaultTracking, _checkDefaultTracking2, _checkDefaultTracking3, _checkDefaultTracking4, _checkDefaultTracking5, _newRow$Product4, _newRow$Product5, checkDefaultTrackingResponse, defaultAdjustmentResponse, getProductResponse, _newRow$Product7, _availableQuantityRes, availableQuantityResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!((_newRow$Product = newRow.Product) !== null && _newRow$Product !== void 0 && _newRow$Product.id))
                        return [2 /*return*/, {
                                id: newRow === null || newRow === void 0 ? void 0 : newRow.id
                            }];
                    rows = (_value$name2 = value === null || value === void 0 ? void 0 : value[name]) !== null && _value$name2 !== void 0 ? _value$name2 : [];
                    if (!(((_newRow$Product2 = newRow.Product) === null || _newRow$Product2 === void 0 ? void 0 : _newRow$Product2.id) !== ((_oldRow$Product = oldRow.Product) === null || _oldRow$Product === void 0 ? void 0 : _oldRow$Product.id))) return [3 /*break*/, 4];
                    return [4 /*yield*/, checkDefaultTrackingTypeAPIGet({
                            key: StockAdjustmentKeys.defaultTracking,
                            request: {
                                ProductId: (_newRow$Product3 = newRow.Product) === null || _newRow$Product3 === void 0 ? void 0 : _newRow$Product3.id
                            },
                            url: checkDefaultTrackingTypeAPI
                        })];
                case 1:
                    checkDefaultTrackingResponse = _a.sent();
                    return [4 /*yield*/, adjustmentTypeListGet({
                            key: 'defaultAdjustment',
                            request: {
                                RequisitionType: 'Adjustment',
                                IsDefault: true
                            },
                            url: AdjustmentTypeList
                        })];
                case 2:
                    defaultAdjustmentResponse = _a.sent();
                    newRow.AdjustmentTypeId = defaultAdjustmentResponse === null || defaultAdjustmentResponse === void 0 || (_defaultAdjustmentRes = defaultAdjustmentResponse.data[0]) === null || _defaultAdjustmentRes === void 0 ? void 0 : _defaultAdjustmentRes.id;
                    newRow.UnitOfMeasurementId = checkDefaultTrackingResponse === null || checkDefaultTrackingResponse === void 0 || (_checkDefaultTracking = checkDefaultTrackingResponse.data) === null || _checkDefaultTracking === void 0 ? void 0 : _checkDefaultTracking.UnitOfMeasurementId;
                    newRow.UOM = checkDefaultTrackingResponse === null || checkDefaultTrackingResponse === void 0 || (_checkDefaultTracking2 = checkDefaultTrackingResponse.data) === null || _checkDefaultTracking2 === void 0 ? void 0 : _checkDefaultTracking2.UnitOfMeasurementName;
                    newRow.DefaultInventoryTrackingType = checkDefaultTrackingResponse === null || checkDefaultTrackingResponse === void 0 || (_checkDefaultTracking3 = checkDefaultTrackingResponse.data) === null || _checkDefaultTracking3 === void 0 ? void 0 : _checkDefaultTracking3.DefaultInventoryTrackingType;
                    newRow.DefaultMaximumQuantity = checkDefaultTrackingResponse === null || checkDefaultTrackingResponse === void 0 || (_checkDefaultTracking4 = checkDefaultTrackingResponse.data) === null || _checkDefaultTracking4 === void 0 ? void 0 : _checkDefaultTracking4.DefaultMaximumQuantity;
                    newRow.DefaultMinimumQuantity = checkDefaultTrackingResponse === null || checkDefaultTrackingResponse === void 0 || (_checkDefaultTracking5 = checkDefaultTrackingResponse.data) === null || _checkDefaultTracking5 === void 0 ? void 0 : _checkDefaultTracking5.DefaultMinimumQuantity;
                    return [4 /*yield*/, getProductPriceAPIGet({
                            key: StockAdjustmentKeys.productPrice,
                            request: {
                                ProductId: (_newRow$Product4 = newRow.Product) === null || _newRow$Product4 === void 0 ? void 0 : _newRow$Product4.id
                            },
                            url: getProductPriceAPI
                        })];
                case 3:
                    getProductResponse = _a.sent();
                    newRow.PurchasePrice = getProductResponse === null || getProductResponse === void 0 ? void 0 : getProductResponse.PurchaseBasePrice.Price;
                    newRow.BasePrice = getProductResponse === null || getProductResponse === void 0 ? void 0 : getProductResponse.SaleMRP.Price;
                    newRow.ProductId = (_newRow$Product5 = newRow.Product) === null || _newRow$Product5 === void 0 ? void 0 : _newRow$Product5.id;
                    _a.label = 4;
                case 4:
                    if (!((_newRow$Product6 = newRow.Product) !== null && _newRow$Product6 !== void 0 && _newRow$Product6.id && newRow.LocationId)) return [3 /*break*/, 7];
                    if (!(newRow.LocationId !== oldRow.LocationId)) return [3 /*break*/, 6];
                    return [4 /*yield*/, getAvailableQuantityAPIGet({
                            key: StockAdjustmentKeys.availableQty,
                            request: {
                                TenantId: UserOrganization,
                                ProductId: (_newRow$Product7 = newRow.Product) === null || _newRow$Product7 === void 0 ? void 0 : _newRow$Product7.id,
                                LocationId: newRow.LocationId
                            },
                            url: getAvailableQuantityAPI
                        })];
                case 5:
                    availableQuantityResponse = _a.sent();
                    newRow.Available = availableQuantityResponse === null || availableQuantityResponse === void 0 || (_availableQuantityRes = availableQuantityResponse.data[0]) === null || _availableQuantityRes === void 0 ? void 0 : _availableQuantityRes.QuantityAvailable;
                    _a.label = 6;
                case 6:
                    newRow.DamagedQuantity = 0;
                    newRow.ExcessQuantity = 0;
                    newRow.CurrentQuantity = 0;
                    newRow.QuantityShortage = 0;
                    return [3 /*break*/, 8];
                case 7:
                    if (!newRow.LocationId) {
                        newRow.Available = undefined;
                    }
                    _a.label = 8;
                case 8: return [2 /*return*/, _objectSpread({}, newRow)];
            }
        });
    }); };
    var getSerialNumberList = function (params) { return __awaiter(_this, void 0, void 0, function () {
        var _await$serialNumberLi, _params$state;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, serialNumberListGet(_objectSpread(_objectSpread({}, params), {}, {
                        request: _objectSpread(_objectSpread({}, params.request), {}, {
                            ProductId: (_params$state = params.state) === null || _params$state === void 0 ? void 0 : _params$state.ProductId,
                            TenantId: UserOrganization
                        })
                    }))];
                case 1: return [2 /*return*/, (_await$serialNumberLi = _a.sent()) !== null && _await$serialNumberLi !== void 0 ? _await$serialNumberLi : {}];
            }
        });
    }); };
    var columns = [{
            type: 'searchSelect',
            field: 'Product',
            headerName: 'Part name & code',
            editable: true,
            flex: 1,
            headerAlign: 'left',
            getOptionLabel: function (value) { return generateCodeName(value, 'SkuCode', 'Name'); },
            valueFormatter: function (value, row) { return row.id === RowModeIds.Total ? 'Total' : value === null || value === void 0 ? void 0 : value.Name; },
            getListData: productListGet,
            apiKey: StockAdjustmentKeys.parts,
            placeholder: 'Enter Part,Code',
            moreButtonText: 'Search More...',
            minWidth: 200,
            renderCell: function (params) {
                var _params$value, _params$value2;
                if (params.id === RowModeIds.Total || !params.value)
                    return params.formattedValue;
                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                    fontSize: "inherit"
                }, (_params$value = params.value) === null || _params$value === void 0 ? void 0 : _params$value.Name), /*#__PURE__*/ React.createElement(Typography, {
                    fontSize: "inherit",
                    color: secondaryTextGray
                }, "#".concat((_params$value2 = params.value) === null || _params$value2 === void 0 ? void 0 : _params$value2.SkuCode)));
            }
        }, {
            type: 'singleSelect',
            field: 'AdjustmentTypeId',
            headerName: 'Adjustment type',
            editable: true,
            flex: 1,
            headerAlign: 'left',
            valueOptions: (_crud$StockAdjustment = (_crud$StockAdjustment2 = crud[StockAdjustmentKeys.adjustmentTypes]) === null || _crud$StockAdjustment2 === void 0 ? void 0 : _crud$StockAdjustment2.data) !== null && _crud$StockAdjustment !== void 0 ? _crud$StockAdjustment : [],
            getOptionLabel: function (value) {
                var _value$Name;
                return (_value$Name = value === null || value === void 0 ? void 0 : value.Name) !== null && _value$Name !== void 0 ? _value$Name : '';
            },
            getOptionValue: function (value) { return value === null || value === void 0 ? void 0 : value.id; },
            placeholder: 'Select type',
            minWidth: 200
        }, {
            field: 'UOM',
            headerName: 'UOM',
            editable: false,
            flex: 1,
            headerAlign: 'left',
            minWidth: 150
        }, {
            type: 'singleSelect',
            field: 'LocationId',
            headerName: 'Location',
            editable: true,
            flex: 1,
            headerAlign: 'left',
            valueOptions: (_crud$StockAdjustment3 = (_crud$StockAdjustment4 = crud[StockAdjustmentKeys.locations]) === null || _crud$StockAdjustment4 === void 0 ? void 0 : _crud$StockAdjustment4.data) !== null && _crud$StockAdjustment3 !== void 0 ? _crud$StockAdjustment3 : [],
            getOptionLabel: function (option) { return generateCodeName(option, 'DisplayName', 'Code'); },
            getOptionValue: function (value) { return value === null || value === void 0 ? void 0 : value.id; },
            minWidth: 200
        }, {
            type: 'number',
            field: 'BasePrice',
            headerName: 'M.R.P (₹)',
            editable: false,
            flex: 1,
            headerAlign: 'right',
            minWidth: 150
        }, {
            type: 'number',
            field: 'PurchasePrice',
            headerName: 'Purchase Cost (₹)',
            editable: false,
            flex: 1,
            headerAlign: 'right',
            minWidth: 150
        }, {
            type: 'number',
            field: 'AdjustedQuantity',
            headerName: 'Qty',
            editable: true,
            flex: 1,
            headerAlign: 'right',
            placeholder: '0',
            minWidth: 150,
            valueSetter: function (value, row) { return _objectSpread(_objectSpread({}, row), {}, {
                AdjustedQuantity: value,
                TotalCostPrice: (value || 0) * row.PurchasePrice
            }); }
        }, {
            type: 'number',
            field: 'Available',
            headerName: 'Available',
            editable: false,
            flex: 1,
            headerAlign: 'right',
            minWidth: 150
        }, {
            type: 'searchSelect',
            field: 'SerialNumber',
            headerName: 'Serial number',
            editable: (crud === null || crud === void 0 || (_crud$StockAdjustment5 = crud[StockAdjustmentKeys.defaultTracking]) === null || _crud$StockAdjustment5 === void 0 || (_crud$StockAdjustment5 = _crud$StockAdjustment5.data) === null || _crud$StockAdjustment5 === void 0 ? void 0 : _crud$StockAdjustment5.DefaultInventoryTrackingType) === 'Serialized' ? true : false,
            flex: 1,
            headerAlign: 'left',
            placeholder: 'Serial number',
            getListData: getSerialNumberList,
            apiKey: StockAdjustmentKeys.serialNumber,
            getOptionLabel: function (option) { return option === null || option === void 0 ? void 0 : option.SerialNumber; },
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.SerialNumber; },
            filterOptions: function (options, params) {
                var filtered = filter(options, params);
                var inputValue = params.inputValue;
                var isExisting = options.some(function (option) { return inputValue === option.SerialNumber; });
                if (inputValue !== '' && !isExisting) {
                    filtered.push({
                        inputValue: inputValue,
                        SerialNumber: "".concat(inputValue)
                    });
                }
                return filtered;
            },
            valueSetter: function (value, row) {
                return _objectSpread(_objectSpread({}, row), {}, {
                    SerialNumber: value,
                    SerialNo: value === null || value === void 0 ? void 0 : value.SerialNumber,
                    AssetId: value === null || value === void 0 ? void 0 : value.id
                });
            },
            minWidth: 200
        }, {
            type: 'number',
            field: 'TotalCostPrice',
            headerName: 'Total Cost (₹)',
            editable: false,
            flex: 1,
            headerAlign: 'right',
            minWidth: 150
        }, {
            field: 'Remarks',
            headerName: 'Remarks',
            editable: true,
            flex: 1,
            headerAlign: 'left',
            placeholder: 'Enter Remarks',
            minWidth: 200
        }];
    return /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        dataGridProps: {
            processRowUpdate: processRowUpdate,
            checkboxSelection: true,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            pinnedRows: {
                bottom: [totalsRow]
            },
            initialState: {
                pinnedColumns: {
                    left: ['__check__', 'Product'],
                    right: ['Remarks']
                }
            },
            isCellEditable: function (params) {
                var _row$Product;
                var row = params.row;
                if (params.field !== 'Product' && !((_row$Product = row.Product) !== null && _row$Product !== void 0 && _row$Product.id)) {
                    return false;
                }
                if (params.field === 'SerialNumber' && row.DefaultInventoryTrackingType !== 'Serialized')
                    return false;
                return params.id !== RowModeIds.Total;
            },
            getRowHeight: function (params) {
                return params.id === RowModeIds.Total ? 44 : undefined;
            },
            disableColumnMenu: true,
            sx: (_a = {
                    borderRadius: 2
                },
                _a["& .".concat(gridClasses['pinnedRows--bottom'], " .").concat(gridClasses.cell)] = {
                    fontWeight: 'bold',
                    background: faintblue
                },
                _a)
        },
        rows: rows !== null && rows !== void 0 ? rows : [],
        onChange: onChange,
        validationModel: {
            AdjustedQuantity: function (value, row) {
                var _crud$StockAdjustment6, _crud$StockAdjustment7, _crud$StockAdjustment8, _crud$StockAdjustment9, _crud$StockAdjustment10;
                if (!value)
                    return undefined;
                if (Number(value) === 0) {
                    return "QTY cannot be zero";
                }
                var maxValue = crud === null || crud === void 0 || (_crud$StockAdjustment6 = crud[StockAdjustmentKeys.defaultTracking]) === null || _crud$StockAdjustment6 === void 0 || (_crud$StockAdjustment6 = _crud$StockAdjustment6.data) === null || _crud$StockAdjustment6 === void 0 ? void 0 : _crud$StockAdjustment6.DefaultMaximumQuantity;
                if ((crud === null || crud === void 0 || (_crud$StockAdjustment7 = crud[StockAdjustmentKeys.defaultTracking]) === null || _crud$StockAdjustment7 === void 0 || (_crud$StockAdjustment7 = _crud$StockAdjustment7.data) === null || _crud$StockAdjustment7 === void 0 ? void 0 : _crud$StockAdjustment7.DefaultInventoryTrackingType) != 'Serialized' && value > maxValue) {
                    return "QTY should not be more than ".concat(maxValue);
                }
                else
                    "";
                var minValue = crud === null || crud === void 0 || (_crud$StockAdjustment8 = crud[StockAdjustmentKeys.defaultTracking]) === null || _crud$StockAdjustment8 === void 0 || (_crud$StockAdjustment8 = _crud$StockAdjustment8.data) === null || _crud$StockAdjustment8 === void 0 ? void 0 : _crud$StockAdjustment8.DefaultMinimumQuantity;
                if ((crud === null || crud === void 0 || (_crud$StockAdjustment9 = crud[StockAdjustmentKeys.defaultTracking]) === null || _crud$StockAdjustment9 === void 0 || (_crud$StockAdjustment9 = _crud$StockAdjustment9.data) === null || _crud$StockAdjustment9 === void 0 ? void 0 : _crud$StockAdjustment9.DefaultInventoryTrackingType) != 'Serialized' && value < minValue) {
                    return "QTY should not be less than ".concat(minValue);
                }
                else
                    "";
                if ((crud === null || crud === void 0 || (_crud$StockAdjustment10 = crud[StockAdjustmentKeys.defaultTracking]) === null || _crud$StockAdjustment10 === void 0 || (_crud$StockAdjustment10 = _crud$StockAdjustment10.data) === null || _crud$StockAdjustment10 === void 0 ? void 0 : _crud$StockAdjustment10.DefaultInventoryTrackingType) === 'Serialized' && (value > 1 || value < -1)) {
                    return 'QTY should be not be more than 1 or less than -1 for Serialized Product';
                }
                else
                    "";
                return "";
            }
        },
        error: error === null || error === void 0 ? void 0 : error[name],
        dataGridHeader: "Part Details"
    });
}
